import IMBgImage from '../../components/common/IMBgImage';
import IMTitle from '../../components/typography/IMText';
import IMButton from '../../components/common/buttons/IMButton';
import IMQuestionsProgressBar from '../../components/common/IMQuestionsProgressBar';
import IMPage from '../../components/common/layout/IMPage';
import { Box, Snackbar, Input } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../store/store';
import { useNavigate } from 'react-router-dom';
import { activateNextVisaCard, answerVisaQuestion, getVisaResult, selectVisaTotalSectionsCount } from '../../store/visaProgramSlice';
import IMText from '../../components/typography/IMTitle';

const VisaQuestions = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch<AppDispatch>();

	const [isError, setIsError] = useState(false)
	const card = useSelector((state: RootState) => state.visaProgram.cards[state.visaProgram.currentCardIndex]);
	const curCardIndex = useSelector((state: RootState) => state.visaProgram.currentCardIndex);
	const sessionToken = useSelector((state: RootState) => state.idealCountry.sessionToken);
	const totalSectionsCount = useSelector(selectVisaTotalSectionsCount);

	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [voteValue, setVoteValue] = useState('');

	useEffect(() => {
		if (!card) {
			navigate('/start');
		}
	}, []);

	const onClickNext = async () => {
		if (!card || !voteValue.trim())
			return setIsError(true);
		if (isError)
			setIsError(false);

		const res = await dispatch(
			answerVisaQuestion({
				cardId: card.id,
				value: voteValue.trim(),
				sessionId: sessionToken,
			})
		);
		if (answerVisaQuestion.rejected.match(res)) {
			setSnackbarOpen(true);
			console.error('Failed to fetch next card', res);
			return;
		}
		setVoteValue('')
		if (card.id === 10) { // finish
			const res2 = await dispatch(getVisaResult({ sessionId: sessionToken }));
			console.log(res2)
			if (getVisaResult.rejected.match(res2)) { // error
				debugger;
			} else {
				debugger;
				navigate('/result/final');
			}
			return;
		}
		dispatch(activateNextVisaCard());
	};

	const handleSnackbarClose = (
		event?: React.SyntheticEvent | Event,
		reason?: string
	) => {
		if (reason === 'clickaway') {
			return;
		}
		setSnackbarOpen(false);
	};

	return (
		card && (
			<IMPage>
				<IMQuestionsProgressBar questionIndex={curCardIndex + 1} totalStages={1} itemsCountInARow={10}></IMQuestionsProgressBar>
				<Box
					sx={{
						position: 'relative',
						height: '100%',
					}}
				>
					<Box
						sx={{
							position: 'absolute',
							height: '100%',
							width: '100%',
							zIndex: 0,
						}}
					>
						<IMBgImage src={card.image_url} alt="" />
					</Box>
					<Box
						sx={{
							position: 'absolute',
							width: '100%',
							bottom: 0,
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								marginBottom: '18px',
								marginX: '16px',
							}}
						>
							<IMTitle
								weight="700"
								size="22px"
								color="#FFFFFF"
								textAlign="center"
							>
								{card.question_text}
							</IMTitle>
							<IMText
								weight="500"
								size="16px"
								color="#FFFFFF"
								opacity={0.7}
								textAlign="center"
								props={{
									mt: 1
								}}
							>
								{card.description}
							</IMText>
							<Box
								sx={{
									mt: 1,
									display: 'flex',
									flexDirection: 'column',
								}}
							>
								<Box
									component={'input'}
									type='text'
									value={voteValue}
									onInput={(e) => setVoteValue((e.target as HTMLInputElement).value)}
									placeholder='Введите информацию'
									onKeyDown={(e) => {
										if (e.key === 'Enter') {
											onClickNext();
										}
									}}
									sx={{
										outlineColor: '#39B54A',
										backgroundColor: '#FFFFFF',
										borderRadius: '10px',
										fontFamily: '"Public Sans",sans-serif',
										height: '56px',
										fontSize: '16px',
										padding: '0 14px',
										marginTop: 1,
										display: 'flex',
										flexDirection: 'column',
										border: isError ? '1px solid #FF0000' : '1px solid #FFFFFF00'
									}}
								/>
							</Box>
						</Box>
					</Box>
				</Box>
				<Box
					sx={{
						paddingX: '16px',
						display: 'flex',
						height: '48px',
						marginBottom: '30px',
					}}
				>
					<IMButton sx={{ width: '100%' }} onClick={onClickNext} >
						Далее
					</IMButton>
				</Box>
				<Snackbar
					open={snackbarOpen}
					autoHideDuration={2000}
					onClose={handleSnackbarClose}
					message="Ошибка при отправке результата"
					anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
				/>
			</IMPage>
		)
	);
};

export default VisaQuestions;
